import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ClassNameProps } from "@msuite/ui/types";
import { formatNumber } from "@msuite/utils/numbers";
import type { IncomingInvoiceStatistics } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoicesSuppliersTileProps extends ClassNameProps {
	topSuppliers: IncomingInvoiceStatistics["topSuppliers"];
}

export function IncomingInvoicesSuppliersTile({
	className,
	topSuppliers,
}: IncomingInvoicesSuppliersTileProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("incoming_invoices.top_suppliers")}
			icon={icon("Building2")}
			isCollapsible={false}
			className={className}
			contentClassName="flex-1"
		>
			<DataGrid>
				{topSuppliers.map((entry) => (
					<DataGrid.Row key={entry.supplier}>
						<DataGrid.Label>{entry.supplier}</DataGrid.Label>
						<DataGrid.Value>{formatNumber(entry.grossAmount, "currency")}</DataGrid.Value>
					</DataGrid.Row>
				))}
			</DataGrid>
		</ContentCard>
	);
}
